import { domain } from 'modules/data';

export const createHelpItemId = (integrationType?: domain.IntegrationType) => {
    return `users-${integrationType || domain.IntegrationType.None}`;
};
